import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyDone = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const returnPath = localStorage.getItem('kycReturnPath') || '/Onboarding';
    localStorage.removeItem('kycReturnPath');
    const timer = setTimeout(() => {
      navigate(returnPath);
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h2>Verification submitted</h2>
      <p>Thanks! We're processing your ID. Returning you to setup...</p>
    </div>
  );
};

export default VerifyDone;
